<template>
  <InputNumber
    :value="Number(info.defaultValue)"
    :placeholder="info.form.placeholder"
    :min="info.form.min"
    :max="info.form.max"
    :size="size"
    :step="info.form.step"
    :precision="info.form.precision"
    :disabled="info.form.disabled||!info.isNew"
    :controls-outside="!!info.form.controlsOutside"
    @input="(value) => info.defaultValue = value" />
</template>

<script>
import { baseComponentMixins } from '../mixins'

export default {
  name: 'BaseInputnumber',
  mixins: [ baseComponentMixins ],
  data() {
    return {}
  },
}
</script>